module.exports = __webpack_public_path__ + "img/podpis-zmluvy.22336316.svg";